import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.querySelector("html").style.scrollBehavior = "initial";
    window.scrollTo(0, 0);
    // return () => {
    //   document.querySelector("html").style.scrollBehavior = "smooth";
    // };
  }, [pathname]);

  return children || null;
};

export default ScrollToTop;
